export default {
  years: "Années",
  countries: "Pays",
  leadership: "Leadership",
  quality: "Qualité",
  solutions: "Solutions",
  facilities: "Installations",
  approvals: "Approbations",
  customers: "Clients",
  operations: "Opérations",
  focused: "Concentré",
  vision: "Vision",
};

